import { useEffect, useState } from 'react';

import api from '../../utils/api';

import User from '../../models/User';

export const useGetUser = () => {
  const [data, setData] = useState(User());
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    let baseURL;
    if (location.origin !== 'https://www.zillow.com') {
      baseURL = 'https://www.qa.zillow.net/';
    }

    let finalResult = User();
    let finalError = false;

    try {
      const data = await api.user.info(
        {
          pageWithSensitiveInformation: false,
          includeSummary: true,
          includeCustomers: true,
          includeProfileImageUrl: true,
        },
        baseURL,
      );

      finalResult = User(data as unknown as Record<string, unknown>);

      setData(finalResult);
    } catch (e) {
      // eslint-disable-next-line
      console.error('ERROR::useGetUser api failed --', e);

      finalError = true;

      setIsError(finalError);
    } finally {
      setIsLoading(false);
    }

    return { data: finalResult, isError: finalError };
  };

  const updateUserEmail = ({ email }: { email: string }) => {
    setData(User({ ...data, email }));
  };

  return { refetch: getUser, data, isLoading, updateUserEmail, isError };
};
